<div
  class="db-product-item db-product-item_view_list product"
  [ngClass]="{
    'db-product-item_view_list_action': (ongoingActivity$ | async)
  }">
  <label for="productItem_{{product.uid}}" class="actions-wrap" >
    <div class="db-product-item__checkbox">
      <label class="db-fc-checkbox" [ngClass]="{
    'selected': product.selected}"><input id="productItem_{{product.uid}}" type="checkbox" [(ngModel)]="product.selected" (change)="onItemToggled()" ><span><i class="db-icon db-icon-check"></i></span></label>
    </div>
  </label>
  <div [ngClass]="{'selected': product.selected}">

    <label for="productItem_{{product.uid}}" class="db-product-item__main-content">
      <div class="db-product-item__info">
        <div class="db-product-item__info-wrap">
          <div class="db-product-item__title">
            <span class="title-wrap" [dbTooltip]="product.title">{{product.title}}</span><span class="db-product-item-excluded-badge" *ngIf="!product.selected">{{'text_productScheduleUpdateExcluded' | dbText}}</span>
          </div>
        </div>
      </div>
    </label>

  </div>
</div>
